import { forwardRef, memo, type Component } from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
// SCSS imports
import { newTag, normal, invisible } from './SkillNewTag.module.scss';

type SkillNewTagProps = {
  readonly active?: boolean | null;
  readonly className?: string;
}

const SkillNewTag = forwardRef<Component<BoxProps>, SkillNewTagProps>(({
  active = false,
  className
}, ref) => (
  <Box
      ref={ref}
      aria-hidden={active ? undefined : 'true'}
      className={clsx(newTag, { [normal]: active, [invisible]: !active }, className)}
  >
    <FormattedMessage id="common.new_skill"/>
  </Box>
));

SkillNewTag.displayName = 'SkillNewTag';

export default memo(SkillNewTag);
